// TOP LEVEL IMPORTS
import React from 'react';
import queryString from 'query-string';
// ANTD
import Spin from 'antd/lib/spin';
import notification from 'antd/lib/notification';
// LIB
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
// APOLLO
import finishConnectingStripe from 'ApolloClient/Mutations/finishConnectingStripe';
import { graphql } from 'react-apollo';

// STYLES
// ===================================
const styles = {
  rowContainer: {
    width: 850,
    maxWidth: '90%',
    margin: 'auto',
    marginTop: 15,
  },
  button: {
    width: 150,
    height: 30,
    borderRadius: 30,
  },
  loaderContainer: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderContentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: 100,
  },
};

// EXPORTED COMPONENT
// ===================================

class StripeChecker extends React.PureComponent {
  state = {
    settingUpPayments: false,
  };

  componentDidMount() {
    this.setComponent();
  }

  setComponent = async () => {
    if (
      this.props.location.search
      && (!this.props.currentUser.organization || !this.props.currentUser.organization.stripeUserIdExists)
    ) {
      this.setState({ settingUpPayments: true });
      let token = queryString.parse(this.props.location.search).code;
      let res;
      let variables = { token };

      if (!token) {
        return null;
      }

      try {
        res = await this.props.finishConnectingStripe({ variables });
      } catch (err) {
        this.setState({ settingUpPayments: false });
        return ErrorHelpers.handleError(err);
      }

      notification.success({ message: 'Stripe successfully connected!' });
      this.props.history.push('/app/studio');
      this.setState({ settingUpPayments: false });
      window.location.reload();
    }
  };

  render() {
    if (this.state.settingUpPayments) {
      return (
        <div style={styles.loaderContainer}>
          <div style={styles.loaderContentContainer}>
            <Spin />
            <h1>Setting up Stripe....</h1>
          </div>
        </div>
      );
    }
    return <span />;
  }
}

export default graphql(finishConnectingStripe, { name: 'finishConnectingStripe' })(StripeChecker);



// WEBPACK FOOTER //
// ./src/routes/app-studio/StripeChecker/index.js